/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Scene_Description_Job_TitleInputs */

const en_confirm_scene_description_job_title = /** @type {(inputs: Confirm_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Shot Description Job Submission`)
};

const fr_confirm_scene_description_job_title = /** @type {(inputs: Confirm_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer la description du plan Soumission de la tâche`)
};

const de_confirm_scene_description_job_title = /** @type {(inputs: Confirm_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigung der Schussbeschreibung für die Stellenbewerbung`)
};

const it_confirm_scene_description_job_title = /** @type {(inputs: Confirm_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma la descrizione dell'inquadratura Invio della candidatura`)
};

const ru_confirm_scene_description_job_title = /** @type {(inputs: Confirm_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердите описание снимка. Отправка заявки на вакансию.`)
};

const es_confirm_scene_description_job_title = /** @type {(inputs: Confirm_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar la descripción de la toma enviada para el trabajo`)
};

const zh_cn2_confirm_scene_description_job_title = /** @type {(inputs: Confirm_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认镜头描述工作提交`)
};

const ja_confirm_scene_description_job_title = /** @type {(inputs: Confirm_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撮影内容の確認 求人応募`)
};

const hi_confirm_scene_description_job_title = /** @type {(inputs: Confirm_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट विवरण जॉब सबमिशन की पुष्टि करें`)
};

const pt_pt2_confirm_scene_description_job_title = /** @type {(inputs: Confirm_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar descrição da cena e envio da vaga`)
};

/**
* | output |
* | --- |
* | "Confirm Shot Description Job Submission" |
*
* @param {Confirm_Scene_Description_Job_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const confirm_scene_description_job_title = /** @type {((inputs?: Confirm_Scene_Description_Job_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Scene_Description_Job_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_confirm_scene_description_job_title(inputs)
	if (locale === "de") return de_confirm_scene_description_job_title(inputs)
	if (locale === "it") return it_confirm_scene_description_job_title(inputs)
	if (locale === "ru") return ru_confirm_scene_description_job_title(inputs)
	if (locale === "es") return es_confirm_scene_description_job_title(inputs)
	if (locale === "zh-CN") return zh_cn2_confirm_scene_description_job_title(inputs)
	if (locale === "ja") return ja_confirm_scene_description_job_title(inputs)
	if (locale === "hi") return hi_confirm_scene_description_job_title(inputs)
	if (locale === "pt-PT") return pt_pt2_confirm_scene_description_job_title(inputs)
	return en_confirm_scene_description_job_title(inputs)
});